import React from 'react';

const INPUT_CLASS =
    'w-full rounded-lg border border-pe-border dark:border-slate-700 bg-pe-input dark:bg-black text-pe-text dark:text-white px-4 py-2.5 text-sm focus:outline-none focus:border-[#E6C299]/50 transition-colors';

const LABEL_CLASS = 'text-xs font-semibold text-pe-muted dark:text-slate-400 uppercase tracking-wider mb-1 block';

interface SondervereinbarungenFieldProps {
    value: string;
    onChange: (value: string) => void;
    dokumentKontext?: 'vertrag' | 'brief';
}

export const SondervereinbarungenField: React.FC<SondervereinbarungenFieldProps> = ({
    value,
    onChange,
    dokumentKontext = 'vertrag',
}) => (
    <div>
        <label className={LABEL_CLASS}>Sondervereinbarungen (optional)</label>
        <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            rows={4}
            placeholder={
                'z. B. Homeoffice, Arbeitskleidung, Firmenwagen, Wettbewerbsklausel …\n\nNur ausfüllen, wenn zusätzlich ein eigener Vertragsparagraf erstellt werden soll.'
            }
            className={`${INPUT_CLASS} resize-y min-h-[100px]`}
        />
        <p className="text-[10px] text-pe-muted dark:text-slate-500 mt-1.5 leading-relaxed">
            Wird nur ins Dokument übernommen, wenn Text vorhanden ist
            {dokumentKontext === 'vertrag' ? ' (als eigener Paragraph).' : '.'}
        </p>
    </div>
);

export const renderSondervereinbarungenInDocument = (
    text: string,
    variant: 'vertrag' | 'brief',
    paragraphNumber?: number
) => {
    const trimmed = text.trim();
    if (!trimmed) return null;

    if (variant === 'vertrag') {
        return (
            <>
                <h3 className="font-bold text-base uppercase border-b border-gray-300 pb-1 mt-6 mb-3">
                    {paragraphNumber ? `§ ${paragraphNumber} Sondervereinbarungen` : 'Sondervereinbarungen'}
                </h3>
                <p className="mb-3 text-justify whitespace-pre-wrap">{trimmed}</p>
            </>
        );
    }

    return (
        <p className="mb-3 text-justify whitespace-pre-wrap">
            <strong>Sondervereinbarungen:</strong> {trimmed}
        </p>
    );
};
